module.exports = __webpack_public_path__ + "img/fatherhood_8.b755d4ab.jpg";